import * as Common from "../../commons/common"
import moment from 'moment';

export class Examinee {
  id: number
  sheet_id: number
  student_no: number
  student_no_character: string
  student_name: string
  absent_flg: boolean
  result_image_created: boolean
  score: number
  saitenCompletedFieldCount: number
  checked: boolean = false
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  fieldActivities: FieldActivity[] = new Array<FieldActivity>()
  base64ScanImages: string[] = new Array<string>();
  base64ResultImages: string[] = new Array<string>();

  constructor(examinee: any, sheetActivities: SheetActivity[], fieldActivities: FieldActivity[], exists_result_image_student_nos: number[]){
    this.id = examinee.id;
    this.sheet_id = examinee.sheet_id;
    this.student_no = examinee.student_no;
    this.student_no_character = examinee.student_no_character;
    this.student_name = examinee.student_name;
    this.absent_flg = examinee.absent_flg;
    this.result_image_created = examinee.result_image_created;
    this.sheetActivities = sheetActivities.filter(x => x.student_id == this.student_no);
    this.sheetActivities.forEach(x => {
      this.fieldActivities = this.fieldActivities.concat(fieldActivities.filter(y => y.sheet_activity_id == x.id));
    });
    this.fieldActivities = this.fieldActivities.sort((a, b) => a.sheet_field_id - b.sheet_field_id);
    this.saitenCompletedFieldCount = this.fieldActivities.filter(x => x.saiten_completed).length;

    // 得点設定 欠席者は得点ソート用に-1を設定（０点の生徒と欠席生徒を区別するため）
    this.score = Common.sumArray(this.fieldActivities.map(x => x.score == null ? 0 : x.score));
    this.score = this.absent_flg ? -1 : this.score;
  }
}

export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number
  reviewTexts: ReviewText[] = new Array<ReviewText>()
  idx: number = 0

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page
  }
}

export class FieldActivity {
  id: number
  sheet_activity_id: number
  sheet_field_id: number
  score: number
  correct_state: number
  saiten_completed: boolean
  
  constructor(fieldActiviby: any){
    this.id = fieldActiviby.id;
    this.sheet_activity_id = fieldActiviby.sheet_activity_id;
    this.sheet_field_id = fieldActiviby.sheet_field_id;
    this.score = fieldActiviby.score;
    this.correct_state = fieldActiviby.correct_state;
    this.saiten_completed = fieldActiviby.saiten_completed;
  }
}

export class Sheet {
  sheet_group_key: number
  grade: number
  room_name: string
  name: string
  curriculum_id: number
  subject_name: string
  exec_date: string
  allot: number
  page_count: number
  sheet_type: number
  approval_flg: boolean
  approved_user_name: string
  approved_at: string
  verify_count: number
  is_digital_paper: boolean
  is_mask_student_info: boolean
  imageWidth: number
  imageHeight: number

  constructor(sheet: any, approved_user_name: string){
    this.sheet_group_key = sheet.sheet_group_key;
    this.grade = sheet.grade;
    this.room_name = sheet.room_name;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.exec_date = sheet.exec_date;
    this.allot = sheet.allot;
    this.page_count = sheet.page_count;
    this.sheet_type = sheet.sheet_type;
    this.approval_flg = sheet.approval_flg;
    this.approved_user_name = approved_user_name;
    this.approved_at =  sheet.approved_at ? moment(sheet.approved_at).format('Y年M月D日') : "";
    this.verify_count = sheet.verify_count;
    this.is_digital_paper = sheet.is_digital_paper;
    this.is_mask_student_info = sheet.is_mask_student_info;
    this.imageWidth = sheet.correct_image_size[0];
    this.imageHeight = sheet.correct_image_size[1];
  }
}

export class SheetField {
  id: number
  part1: string
  part2: string
  part3: string
  allot: number
  allotCache: number
  scoreAverage: number
  scoreRate: number
  FieldActivities: FieldActivity[] = new Array<FieldActivity>()
  isSaitenCompleted: boolean
  firstSaitenCompletedCount: number
  secondSaitenCompletedCount: number
  thirdSaitenCompletedCount: number
  second_scorers_id: number | null
  third_scorers_id: number | null
  first_user_name: string | null
  second_user_name: string | null
  third_user_name: string | null
  scoring_type: number | null

  constructor(sheetField: any, fieldActivities: FieldActivity[], sheet: Sheet){
    this.id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.allot = sheetField.allot;
    this.allotCache = sheetField.allot;
    this.FieldActivities = fieldActivities.filter(x => x.sheet_field_id == this.id);
    const totalScore: number = Common.sumArray(this.FieldActivities.map(x => x.score == null ? 0 : x.score));
    this.scoreAverage = Number((totalScore / this.FieldActivities.length).toFixed(1));
    this.scoreRate = Math.round(totalScore / (this.allot * this.FieldActivities.length) * 100);
    this.second_scorers_id = sheetField.second_scorers_id;
    this.third_scorers_id = sheetField.third_scorers_id; 
    this.isSaitenCompleted = this.FieldActivities.filter(x => !x.saiten_completed).length == 0;
    this.firstSaitenCompletedCount = this.FieldActivities.filter(x => x.saiten_completed).length;
    this.secondSaitenCompletedCount = this.second_scorers_id == null ? 0 : this.firstSaitenCompletedCount;
    this.thirdSaitenCompletedCount = this.third_scorers_id == null ? 0 : this.firstSaitenCompletedCount;
    this.first_user_name = sheetField.first_scorers_id && !sheetField.first_user_name ? "削除されたユーザ" : sheetField.first_user_name;
    this.second_user_name = sheetField.second_scorers_id && !sheetField.second_user_name ? "削除されたユーザ" : sheetField.second_user_name;
    this.third_user_name = sheetField.third_scorers_id && !sheetField.third_user_name ? "削除されたユーザ" : sheetField.third_user_name;
    this.scoring_type = sheetField.scoring_type;

    if(sheet.sheet_type == Common.SheetTypeEnum.Entrance || sheet.sheet_type == Common.SheetTypeEnum.Practice){
      this.isSaitenCompleted = this.secondSaitenCompletedCount == this.FieldActivities.length;
    }else{
      this.isSaitenCompleted = this.firstSaitenCompletedCount == this.FieldActivities.length;
    }
  }
}

export class ScoreOption {
  value: number
  text: string

  constructor(value: number, text: string){
    this.value = value;
    this.text = text;
  }
}

export class ReviewText {
  id: number
  sheet_activity_id: number
  idx: number
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_text: string = null
  is_active: boolean = false
}